<div class="whitespace-nowrap overflow-hidden flex-1">
  <ng-content></ng-content>
</div>

@if (displayCloseBtn) {
  <span
    data-test-id="close-button"
    class="close-btn cursor-pointer group rounded-md hover:bg-white inline-flex justify-center items-center h-8 w-8"
    (click)="closeClick.emit()"
  >
    <svg class="w-5 h-5" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.90376 1.15506C1.69701 0.948313 1.36181 0.948313 1.15506 1.15506C0.948313 1.36181 0.948313 1.69701 1.15506 1.90376L9.2513 10L1.15506 18.0962C0.948313 18.303 0.948313 18.6382 1.15506 18.8449C1.36181 19.0517 1.69701 19.0517 1.90376 18.8449L10 10.7487L18.0962 18.8449C18.303 19.0517 18.6382 19.0517 18.8449 18.8449C19.0517 18.6382 19.0517 18.303 18.8449 18.0962L10.7487 10L18.8449 1.90376C19.0517 1.69701 19.0517 1.36181 18.8449 1.15506C18.6382 0.948313 18.303 0.948313 18.0962 1.15506L10 9.2513L1.90376 1.15506Z"
        fill="white"
      />
    </svg>
  </span>
}
